import React from "react";
export default function CorrectInfo(props) {
    return (React.createElement("span", { className: "info-correct" }, props.text));
}
